import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { Button, Typography, Box } from '@mui/material';
import DoneRounded from '@mui/icons-material/DoneRounded';
import EditorAccordion from '../EditorAccordion';
import CustomOutlinedChip from '../../../../../Components/Chip/CustomOutlinedChip';

const ExistingCtaTab = function ExistingCtaTab({ existingCta = [] }) {
  const intl = useIntl();
  const { reset, getValues } = useFormContext();

  const handleClickCta = (data) => {
    reset(data);
  };

  return (
    <>
      {existingCta.map(({ ctaId, text, tagId, responseText }) => {
        return (
          <EditorAccordion
            key={ctaId}
            open
            hideExpandIcon
            onClick={() => handleClickCta({ ctaId, text, tagId, responseText })}
            expandIcon={
              getValues('ctaId') === ctaId ? (
                <DoneRounded sx={{ transform: 'rotate(180deg)' }} />
              ) : null
            }
            ParentTitleComponent={
              <Box
                sx={{
                  width: "100%",
                  height: "100%"
                }}>
                <Button
                  onClick={() => {}}
                  variant="contained"
                  // endIcon={icon}
                  size="large"
                  sx={{ alignSelf: 'center', m: '8px' }}
                >
                  {text}
                </Button>
              </Box>
            }
            alternativeContent={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  padding: '24px',
                }}
              >
                <CustomOutlinedChip label={intl.messages[tagId]} />
                <Typography variant="body2">{responseText}</Typography>
              </div>
            }
          />
        );
      })}
    </>
  );
};

ExistingCtaTab.propTypes = {
  existingCta: PropTypes.array,
};

export default ExistingCtaTab;
